module.exports = __webpack_public_path__ + "6aeb2b4fb8be3e19739018ff4bf75b08.svg";